<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Pcas />
    </v-container>
  </div>
</template>

<script>
import Pcas from "../../components/Definiciones/Pcas/Pcas.vue";
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
export default {
  components: { Pcas, LandingToolbar },
};
</script>
